import { TextFieldProps } from "@mui/material";
import { FieldProps } from "formik";
import React from "react";
import { InviteCheckbox } from "./InviteCheckbox";

export interface FormikCheckboxProps
  extends FieldProps<boolean>,
    Omit<TextFieldProps, "name" | "value" | "error" | "onChange"> {}

export const FormikCheckbox: React.FC<FormikCheckboxProps> = ({ ...props }) => (
  <InviteCheckbox
    value={props.field.value}
    onChange={(invite: boolean) => {
      props.field.onChange({
        name: props.field.name,
        target: {
          name: props.field.name,
          value: invite,
        },
      });
    }}
  />
);
